"use client";

import { useEffect } from "react";
import confetti from "canvas-confetti";

export default function ConfettiBlast() {

    useEffect(() => {


        confetti({
            particleCount: 300,
            spread: 150,
            startVelocity: 45,
            origin: { x: 0.5, y: 0.6 } // center blast
        });


    }, []);

    return null;
}